/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2MedicalHistoryTaskIcon1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import Tysiav2MedicalHistoryTaskIcon from 'DesignSystem/Svgs/Tysiav2MedicalHistoryTaskIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2MedicalHistoryTaskIcon1({
  children,
  viewPath = "/DesignSystem/TaskBoardIcon/Icon/Tysiav2MedicalHistoryTaskIcon",
  height,
  width
  
}) {
let iconColorValueData = fromData.useDataValue({ viewPath,
context: 'icon',
path: 'color',
})
  return (<React.Fragment
>
<Tysiav2MedicalHistoryTaskIcon
  viewPath={`${viewPath}/Tysiav2MedicalHistoryTaskIcon`}
 data="icon.color"
 fill2={iconColorValueData}
 height={height}
 width={width}
/>
{children}
</React.Fragment>)
}